<template>
  <div class="col px-0 contact d-flex flex-column">
    <div class="content-title">
      <div class="media">
        <div class="media-body">
          <h1>
            {{ $t("feature.homecare.title") }}
          </h1>
          <breadcrumbs :labels="breadcrumbsLabels"></breadcrumbs>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import Breadcrumbs from "./Breadcrumbs";

export default {
  components: {
    Breadcrumbs
  },
  data() {
    return {
      projectName: localStorage.getItem("projectName"),
      breadcrumbsLabels: ["โครงการทั้งหมด"]
    };
  },
  watch: {
    $route() {
      this.breadcrumbsLabels = ["โครงการทั้งหมด"];
      this.projectName = localStorage.getItem("projectName");
      this.setBreadcrumbs();
    }
  },
  methods: {
    setBreadcrumbs() {
      if (this.projectName) {
        this.breadcrumbsLabels.push(this.projectName);
      }
      if (!localStorage.getItem("projectId")) {
        this.$router.push({ name: "HomecareProject" });
      }
    }
  },
  created() {
    this.setBreadcrumbs();
  }
};
</script>

<style lang="scss">
.homecare-status {
  &.CLS {
    color: #00b793;
  }
  &.OPN {
    color: #a28676;
  }
  &.WINP {
    color: #e27024;
  }
  &.INP {
    color: #e27024;
  }
  &.RVW {
    color: #e27024;
  }
  &.CNC {
    color: #a28676;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/layout/HomecareLayout.vue